/**
 * Copyright (C) Boost commerce
 * This file is part of commercial Boost commerce projects
 *
 * This file can not be copied and/or distributed without the express
 * permission of Boost commerce
 *
 * Created on Mon Jan 08 2024 08:48:11
 */
import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { getShop } from 'src/helpers';
import { URL } from 'src/constants/links';
import moment from 'moment';
import YepPopup2023 from 'src/assets/images/dashboard-v3/yep-popup-2023.png';
import CustomModal from 'src/components/views/common/custom-modal';

export default function YearEndReviewPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const shop = getShop();
      const firstDisplay = localStorage.getItem(`${shop}-YearEndReviewPopup2023-firstDisplay`);
      const lastDisplay = localStorage.getItem(`${shop}-YearEndReviewPopup2023-lastDisplay`);

      const now = moment().startOf();

      if (now.isAfter(moment('2024-02-09'))) {
        return;
      }

      if (firstDisplay && lastDisplay) {
        if (
          now.diff(moment(firstDisplay).startOf(), 'days') >= 4 ||
          now.diff(moment(lastDisplay).startOf(), 'day') < 1
        ) {
          return;
        }
      } else if (!firstDisplay) {
        localStorage.setItem(`${shop}-YearEndReviewPopup2023-firstDisplay`, moment().toISOString());
      }

      // Display the popup after 3 seconds since users land on the dashboard
      setTimeout(() => {
        setOpen(true);
      }, 3000);
    } catch (error) {}
  }, []);

  const handleClose = useCallback(() => {
    try {
      const shop = getShop();
      localStorage.setItem(`${shop}-YearEndReviewPopup2023-lastDisplay`, moment().toISOString());
    } catch (error) {
    } finally {
      setOpen(false);
    }
  }, []);

  const handleBtnClick = useCallback(() => {
    window.open(URL['YearEndReview2023'], '_blank');

    try {
      const shop = getShop();
      localStorage.setItem(
        `${shop}-YearEndReviewPopup2023-firstDisplay`,
        moment('2023-12-01').toISOString()
      );

      handleClose();
    } catch (error) {}
  }, [handleClose]);

  return (
    <CustomModal open={open} className="PFS-YEP-Popup-Container">
      <div className="PFS-YEP-Popup">
        <img src={YepPopup2023} alt="Year end review in app popup 2023" usemap="#image_map" />
        <map name="image_map">
          <area
            alt=""
            href=""
            title="Get started"
            coords="326,452,491,495"
            shape="rect"
            onClick={e => {
              e.preventDefault();
              handleBtnClick();
            }}
          />
        </map>
        <div className="closeBtn">
          <Button onClick={handleClose} icon={MobileCancelMajor} plain />
        </div>
      </div>
    </CustomModal>
  );
}
